import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { FormDataService } from 'src/app/shared/attachments/service/form-data.service';
import { IProductType } from '../models/product-type.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class ProductTypeApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/${getDepartmentId()}/ProductTypes`;
  }

  constructor(private http: HttpClient) {}

  loadProductTypes(currentFilter?: MainTableFilterModel): Observable<ApiResponse<IProductType[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IProductType[]>>(this.url, { params });
  }

  loadAllProductTypes(): Observable<IProductType[]> {
    const url = `${this.url}/List`;
    return this.http.get<IProductType[]>(url);
  }

  loadProductTypeById(id: string): Observable<IProductType> {
    const url = `${this.url}/${id}`;
    return this.http.get<IProductType>(url);
  }

  createProductType(productType: IProductType): Observable<IProductType> {
    const formData = FormDataService.mapToFormData(productType);
    return this.http.post<IProductType>(this.url, formData);
  }

  updateProductType(productType: IProductType): Observable<IProductType> {
    const formData = FormDataService.mapToFormData(productType);
    const url = `${this.url}/${productType.id}`;
    return this.http.put<IProductType>(url, formData);
  }

  deleteProductType(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
